
export class Record {
	moviment: string;
	hired: any;
	used: any;
	excess: any;
	value: any;
	total: any;

	constructor(
		moviment: string,
		hired: any,
		used: any,
		excess: any,
		value: any,
		total: any,
	) {
		this.moviment = moviment;
		this.hired = hired;
		this.used = used;
		this.excess = excess;
		this.value = value;
		this.total = total;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/rate-package/models/record.ts